// ** Modules
import React from 'react';

// ** Components
import Section from '@/components/common/Section';
import { CompetitionGridBlock } from '@/features/ap-plus';

// ** Utils
import { getStrapiImageUrl } from '@/utils/api/strapi';

// ** Types
import type { StrapiComponentProps } from '@/types/strapi';
import type { CompetitionCardModel, ImageEntry } from '@/components/common/CompetitionCard';
import type { ComponentBlocksCompetitionCards as BlocksCompetitionCardsProps } from '@/types/graphql';

type ComponentBlocksCompetitionCardsProps = StrapiComponentProps<BlocksCompetitionCardsProps>;

const ComponentBlocksCompetitionCards = ({
	host,
	containerSx,
	competitionCardsSectionTitle,
	competitionCardsContent
}: ComponentBlocksCompetitionCardsProps) => {
	const items: CompetitionCardModel[] = React.useMemo(() => {
		return (competitionCardsContent ?? [])
			.filter((entry): entry is NonNullable<typeof entry> => entry !== null && entry !== undefined)
			.map((entry) => {
				const extraImages: ImageEntry[] = (entry.competitionCardExtraImages ?? [])
					.filter((img): img is NonNullable<typeof img> => img !== null && img !== undefined)
					.map((img) => ({
						src:
							getStrapiImageUrl({
								host,
								imageData: img.image,
								isMobile: false
							}) || '',
						alt: img.image?.alternativeText || '',
						videoUrl: img.videoUrl || undefined
					}));

				return {
					id: entry.id,
					name: entry.competitionCardName || '',
					description: entry.competitionCardDescription || '',
					cta: entry.competitionCardCta || undefined,
					ranking: entry.competitionCardRanking as 1 | 2 | 3 | undefined,
					imageData: entry.competitionCardImage ?? undefined,
					imageAlt: entry.competitionCardImage?.alternativeText || '',
					host,
					detail: {
						fullDescription: entry.competitionCardFullDescription || undefined,
						trainingCompany: entry.competitionCardTrainingCompany || undefined,
						guild: entry.competitionCardGuild || undefined,
						material: entry.competitionCardMaterial || undefined,
						extraImages: extraImages.length > 0 ? extraImages : undefined
					}
				};
			});
	}, [competitionCardsContent, host]);

	return (
		<Section backgroundColor="#F6F4F2" containerSx={containerSx}>
			<CompetitionGridBlock title={competitionCardsSectionTitle || undefined} items={items} />
		</Section>
	);
};

export default ComponentBlocksCompetitionCards;
